import { render, staticRenderFns } from "./QuestionResponsePage.vue?vue&type=template&id=ff391cf8"
import script from "./QuestionResponsePage.vue?vue&type=script&lang=js"
export * from "./QuestionResponsePage.vue?vue&type=script&lang=js"
import style0 from "./QuestionResponsePage.vue?vue&type=style&index=0&id=ff391cf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports